// recharts-free chart helpers (a card wrapper + the shared palette). Kept in a
// SEPARATE module from charts.tsx so the heavy recharts code can be lazy-loaded
// while the card chrome + colors stay in the main bundle.
import type { ReactNode } from 'react';

// Palette pulled from the CSS tokens (rgb tuples in styles/index.css).
export const CHART = {
  primary: '#388eff',
  ok: '#22c55e',
  warning: '#eab308',
  critical: '#ef4444',
  muted: '#94a3b8',
  grid: 'rgba(255,255,255,0.06)',
  axis: '#94a3b8',
};

export function ChartCard({ title, icon, children, action }: { title: string; icon?: ReactNode; children: ReactNode; action?: ReactNode }) {
  return (
    <div className="tk-card p-4">
      <div className="mb-3 flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm font-medium">{icon}{title}</div>
        {action}
      </div>
      {children}
    </div>
  );
}

export function EmptyChart({ note }: { note: string }) {
  return <div className="grid h-[220px] place-items-center text-sm text-muted">{note}</div>;
}
